import React, {useState} from 'react';
import TopBar from '../../../../Components/TopBar';
import Page from '../../../../Components/Containers/Page';
import { useBalance, usePayouts } from '../../../../Data/Balance';
import Money from '../../../../Components/Formatting/Money';
import { PageLoading } from '../../../../Components/Loading';
import Button from '../../../../Components/Button/Button';
import PayoutThreshold from './PayoutThreshold';
import DateTime from '../../../../Components/Formatting/DateTime';
import PayoutInfo from './PayoutInfo';
import RequestPayout from './RequestPayout';

const Payouts = () => {
    const {balance, payments, refresh: refreshBalance} = useBalance();
    const {payouts, refresh: refreshPayouts} = usePayouts();
    const [changingPayoutThreshold, setChangingPayoutThreshold] = useState(false);
    const [requestingPayout, setRequestingPayout] = useState(false);

    const refreshAll = async () => {
        return Promise.all([refreshBalance(), refreshPayouts()]);
    }

    return <>
        <TopBar
            left="/more"
            title="Payouts"
            dropdownOptions={[
                {
                    title: 'Payout threshold',
                    icon: 'Slider',
                    onClick: () => setChangingPayoutThreshold(true)
                },
                {
                    title: 'Request payout',
                    icon: 'MoneyBillTransfer',
                    onClick: () => setRequestingPayout(true)
                },
            ]}
        />
        <Page>
            {balance ? <Inner {...{balance, payments, payouts}} /> : <PageLoading />}
        </Page>

        <PayoutThreshold isOpen={changingPayoutThreshold}
            setIsOpen={setChangingPayoutThreshold}
            onChanged={refreshBalance}
        />
        <RequestPayout isOpen={requestingPayout}
            setIsOpen={setRequestingPayout}
            onChanged={refreshAll}
        />
    </>
}

const Inner = ({balance, payments, payouts}) => {
    return <>
        <div className="flex flex-col divide-y w-full">
            <Row title="Payable balance"
                info={<Money pence={balance.payablePence} colour />}
            />
            <Row title="Payments pending"
                info={<>
                    <Money pence={payments.total} />
                    &nbsp;
                    ({payments.count})
                </>}
            />
            <Row title="Payout threshold"
                info={<Money pence={balance.payoutThreshold} hidePence />}
            />

        </div>

        <PayoutsList payouts={payouts} />
    </>
}

const PayoutsList = ({payouts}) => {
    const [showingDetails, setShowingDetails] = useState(null);

    if (!payouts) {
        return <PageLoading />
    }

    return <div className="flex flex-col my-8">
        <h3 className="font-bold mb-2">Payouts</h3>
        {payouts.length === 0 && <p className="text-muted text-center">No payouts</p>}

        {payouts.map((payout) => {
            return <div key={payout.id} className="grid grid-cols-4 pb-4 mt-4 border-b">
                <div className="font-bold">
                    <Money pence={payout.changePence} />
                </div>
                <div className="col-span-2">
                    <p className="text-muted">
                        <DateTime date={payout.adjustedAt} hideTime />
                    </p>
                </div>
                <div className="text-right">
                    <Button theme="light"
                        icon="Info"
                        onClick={() => setShowingDetails(payout.details)}
                        disabled={!payout.details}
                        zeroMargin
                    />
                </div>
            </div>
        })}

        <PayoutInfo payout={showingDetails} close={() => setShowingDetails(null)} />
    </div>
}

const Row = ({hide, title, info}) => {
    if (hide) {
        return null;
    }

    return <div className="flex flex-row justify-between py-4">
        <div className="grow">
            <p className="font-bold mb-2">
                {title}
            </p>
        </div>
        <div className="shrink-0">
            {info}
        </div>
    </div>
}


export default Payouts;
